import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { mp } from "../utils/mixpanel";

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    mp.track("Page View", {
      path: location.pathname,
      search: location.search,
    });
  }, [location.pathname, location.search]);
}